import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

interface ActionTile {
  value: string;
  label: string;
  description: string;
  icon: string;
}

@Component({
  selector: 'app-step-vm-cleanup',
  templateUrl: './step-vm-cleanup.component.html',
  styleUrls: ['./step-vm-cleanup.component.css']
})
export class StepVmCleanupComponent {
  @Input() form!: FormGroup;
  @Input() stepLabel = 'Cleanup';
  /** 'daily' locks grace period to minutes (5–360). 'classEnd' allows hours/days only. */
  @Input() graceConstraint: 'daily' | 'classEnd' = 'classEnd';

  readonly actionTiles: ActionTile[] = [
    { value: 'DoNothing',   label: 'Do Nothing',   description: 'Resources remain running untouched.',      icon: 'block' },
    { value: 'Shutdown',    label: 'Shutdown',      description: 'Gracefully shut down the VM.',            icon: 'power_settings_new' },
    { value: 'Deallocate',  label: 'Deallocate',    description: 'Stop and deallocate the VM to save cost.', icon: 'stop_circle' },
    { value: 'Destroy',     label: 'Destroy',       description: 'Permanently delete VM resources.',         icon: 'delete_forever' },
  ];

  readonly classEndGracePeriodUnits = ['Hours', 'Days'];

  readonly destroyScopeTiles = [
    {
      value: 'ComputeOnly',
      label: 'Compute Only',
      description: 'Deletes the VM, NIC, public IP, and other ancillary infrastructure. The managed disk is retained.'
    },
    {
      value: 'ComputeAndDisk',
      label: 'Compute + Disk',
      description: 'Deletes the VM, NIC, public IP, ancillary infrastructure, and the managed disk.'
    },
  ];

  get selectedAction(): string {
    return this.form?.get('actionType')?.value ?? 'DoNothing';
  }

  get isDaily(): boolean {
    return this.graceConstraint === 'daily';
  }

  selectAction(value: string): void {
    this.form.get('actionType')?.setValue(value);
    if (value === 'DoNothing') {
      this.form.get('gracePeriodValue')?.setValue(null);
      this.form.get('gracePeriodUnit')?.setValue(null);
      this.form.get('destroyScope')?.setValue(null);
    }
    this.form.updateValueAndValidity();
  }

  selectDestroyScope(value: string): void {
    this.form.get('destroyScope')?.setValue(value);
    this.form.updateValueAndValidity();
  }
}
